// extracted by mini-css-extract-plugin
export default {"trigger":"styles__trigger___ARvHf","tip":"styles__tip___wlpKp"};